module.exports = ".txt-content {\n  height: 300px; }\n\n.txt-description {\n  height: 100px; }\n"